import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4 flex items-center text-sm"
}
const _hoisted_2 = {
  key: 0,
  class: "mx-2 text-gray-500"
}
const _hoisted_3 = {
  key: 2,
  class: "mx-2 text-gray-500"
}
const _hoisted_4 = {
  key: 4,
  class: "mx-2 text-gray-500"
}
const _hoisted_5 = {
  key: 6,
  class: "mx-2 text-gray-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.activeView !== '')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_router_link, {
          to: "/administration",
          class: "text-blue-600 hover:text-blue-800"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" Administration ")
          ])),
          _: 1
        }),
        (_ctx.activeView === 'email-templates')
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "/"))
          : _createCommentVNode("", true),
        (_ctx.activeView === 'email-templates')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: "/administration/email-templates",
              class: "text-gray-700 hover:text-blue-800"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode(" Email Template Management ")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.activeView === 'user-roles')
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "/"))
          : _createCommentVNode("", true),
        (_ctx.activeView === 'user-roles')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 3,
              to: "/administration/user-roles",
              class: "text-gray-700 hover:text-blue-800"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" User Role Management ")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.activeView === 'system-config')
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "/"))
          : _createCommentVNode("", true),
        (_ctx.activeView === 'system-config')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 5,
              to: "/administration/system-config",
              class: "text-gray-700 hover:text-blue-800"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" System Configuration ")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.activeView === 'audit-logs')
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "/"))
          : _createCommentVNode("", true),
        (_ctx.activeView === 'audit-logs')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 7,
              to: "/administration/audit-logs",
              class: "text-gray-700 hover:text-blue-800"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode(" Audit Logs ")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}